import react from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Container from "./component/body/home/Container";
import Pages from "./component/body/pages/Pages";
import Header from "./component/header/Header";

function App() {
  return (
    <div className="App">
      <div className="header">
        <Header />
      </div>
      <div className="body">
        <Routes>
          <Route path="/" element={<Container />} />
          <Route path="projects" element={<Pages />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
